enum TypographyFontStyles {
  Regular = 'Regular',
  Semibold = 'Semibold',
  Bold = 'Bold',
}

export default TypographyFontStyles;
